function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, DatePicker, Button, Statistic, Descriptions, Tag } from 'antd';
import { Col, Container, Row } from 'react-bootstrap';
import Common from "../components/includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Reports = function Reports() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    rdata = _useState2[0],
    setRdata = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get("".concat(Common.baseApiUrl, "getdashboard/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setRdata(response.data.dashdata);
      } else {
        notification.error({
          message: "Erreur",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue"
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "stat_wrapper",
            style: {
              background: "#A8675C"
            },
            children: rdata && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("h4", {
                children: /*#__PURE__*/_jsx("b", {
                  style: {
                    color: "#EEE"
                  },
                  children: "Total ventes"
                })
              }), /*#__PURE__*/_jsx(Row, {
                children: /*#__PURE__*/_jsx(Col, {
                  children: /*#__PURE__*/_jsxs(Descriptions, {
                    column: 1,
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      contentStyle: {
                        color: "#FFF"
                      },
                      labelStyle: {
                        color: "#FFF"
                      },
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Jour "
                      }),
                      children: rdata.total_sales_day.toLocaleString("Fr")
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      contentStyle: {
                        color: "#FFF"
                      },
                      labelStyle: {
                        color: "#FFF"
                      },
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Semaine "
                      }),
                      children: rdata.total_sales_week.toLocaleString("Fr")
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      contentStyle: {
                        color: "#FFF"
                      },
                      labelStyle: {
                        color: "#FFF"
                      },
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Mois "
                      }),
                      children: rdata.total_sales_month.toLocaleString("Fr")
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      contentStyle: {
                        color: "#FFF"
                      },
                      labelStyle: {
                        color: "#FFF"
                      },
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Ann\xE9e "
                      }),
                      children: rdata.total_sales_year.toLocaleString("Fr")
                    })]
                  })
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "stat_wrapper",
            style: {
              background: "#665E5D"
            },
            children: rdata && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("h4", {
                children: /*#__PURE__*/_jsxs("b", {
                  style: {
                    color: "#EEE"
                  },
                  children: ["Total clients: ", rdata.total_leads]
                })
              }), /*#__PURE__*/_jsx(Row, {
                children: /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: /*#__PURE__*/_jsxs(Descriptions, {
                    column: 1,
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      contentStyle: {
                        color: "#FFF"
                      },
                      labelStyle: {
                        color: "#FFF"
                      },
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Jour"
                      }),
                      children: rdata.total_leads_day.toLocaleString("Fr")
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      contentStyle: {
                        color: "#FFF"
                      },
                      labelStyle: {
                        color: "#FFF"
                      },
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Semaine"
                      }),
                      children: rdata.total_leads_week.toLocaleString("Fr")
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      contentStyle: {
                        color: "#FFF"
                      },
                      labelStyle: {
                        color: "#FFF"
                      },
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Mois"
                      }),
                      children: rdata.total_leads_month.toLocaleString("Fr")
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      contentStyle: {
                        color: "#FFF"
                      },
                      labelStyle: {
                        color: "#FFF"
                      },
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Ann\xE9e"
                      }),
                      children: rdata.total_leads_year.toLocaleString("Fr")
                    })]
                  })
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "stat_wrapper",
            style: {
              background: "#6A7872"
            },
            children: [/*#__PURE__*/_jsx("h4", {
              children: /*#__PURE__*/_jsx("b", {
                style: {
                  color: "#EEE"
                },
                children: "Total versements "
              })
            }), rdata && /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(Row, {
                children: /*#__PURE__*/_jsx(Col, {
                  children: /*#__PURE__*/_jsx(Descriptions, {
                    column: 1,
                    children: /*#__PURE__*/_jsx(Descriptions.Item, {
                      contentStyle: {
                        color: "#FFF"
                      },
                      labelStyle: {
                        color: "#FFF"
                      },
                      label: /*#__PURE__*/_jsx("b", {
                        children: "En attente de validation"
                      }),
                      children: rdata.total_deposit_pending
                    })
                  })
                })
              })
            })]
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          sm: 12,
          children: /*#__PURE__*/_jsx("div", {
            className: "stat_wrapper",
            style: {
              background: "#FFDE59"
            },
            children: rdata && /*#__PURE__*/_jsx(Statistic, {
              title: /*#__PURE__*/_jsx("b", {
                children: "Total agents"
              }),
              value: rdata.total_agents
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 12,
          children: /*#__PURE__*/_jsx("div", {
            className: "stat_wrapper",
            children: rdata && /*#__PURE__*/_jsx(Statistic, {
              title: /*#__PURE__*/_jsx("b", {
                children: "Total articles"
              }),
              value: rdata.total_items
            })
          })
        })]
      })]
    })
  });
};
export default Reports;